import CommonActionType from "../actiontype/common.actiontype";
import { ConsentAppActionType } from "../actiontype/consent-app.actiontype";
import { ConsentAppPages } from "../constants/consent-app.constants";

const initialState = {
    activePage: ConsentAppPages.CONSENT_HOME_PAGE,
    activeInfoScreen: null,
    loginNotificationFlag: true
};

export function consentAppReducer(state = initialState, action) {
    switch (action.type) {
        case ConsentAppActionType.SET_ACTIVE_CONSENT_PAGE_NAME:
            return { ...state, activePage: action.payload }
        case ConsentAppActionType.SET_ACTIVE_CONSENT_SCREEN_NAME:
            return { ...state, activeInfoScreen: action.payload }
        case ConsentAppActionType.SET_LOGIN_NOTIFICATION_FLAG:
            return { ...state, loginNotificationFlag: action.payload }
        case CommonActionType.RESET_STATE:
            return { ...initialState }
        default:
            return state;
    }
}